import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import SnackbarComposables from '../composables/SnackbarComposables';
import { useApi } from '../composables/useApi';
import { getCurrentInstance } from 'vue';
import { store as rootStore } from '../store';
import rootI18n from '../i18n';

const IncheckReferenceService = () => 
{
    /* Data */
    const ApiClient = useApi();
    const hasInstance = !!getCurrentInstance();
    const store = hasInstance ? useStore() : rootStore;

    let t, locale, addSnackbar;
    if (hasInstance)
    {
        const i18n = useI18n();
        t = i18n.t;
        locale = i18n.locale;
        const snackbar = SnackbarComposables();
        addSnackbar = snackbar.addSnackbar;
    }
    else
    {
        t = (key, ...args) => rootI18n.global.t(key, ...args);
        locale = { value: rootStore.state.locale };
        addSnackbar = () => {};
    }

    /* Methods */
    /**
     * Il 409 `period_already_reported` non e' un guasto: e' lo stato del
     * periodo, che puo' essere cambiato in un'altra scheda dopo che questa
     * pagina ha caricato la tabella. Va restituito come esito, non lasciato
     * salire come eccezione, altrimenti chi ha cliccato Salva resta a
     * guardare uno spinner.
     */
    const updateIncheckReference = async(incheckReferenceId, payload) => 
    {
        store.commit('errors/CLEAR_STATE');

        let res;

        try
        {
            res = await ApiClient.put(`incheck-reference/${incheckReferenceId}`, payload);
        }
        catch (e)
        {
            if(e.response && e.response.data && e.response.data.error === 'period_already_reported')
            {
                addSnackbar('warning', t('updateQuantityModal.periodReported', store.state.locale));

                return 409;
            }

            throw e;
        }

        if(res)
        {
            if(res.data && res.data.incheck_reference)
            {
                addSnackbar('success', t('product.update.createdMessage', store.state.locale));
                return 200;
            }
            else
            {
                addSnackbar('error', t('snackbar.refresh', store.state.locale));
            }
            return res;
        }
    };
    const destroyIncheckReference = async(incheckReferenceId) => 
    {
        store.commit('errors/CLEAR_STATE');
        const res = await ApiClient.delete(`incheck-reference/delete/${incheckReferenceId}`);
        if(res)
        {
            if(res.status === 200)
            {
                return 200;
            }
            else
            {
                addSnackbar('error', t('snackbar.refresh', store.state.locale));
            }
            return res;
        }
    };
    const setNoMatchInIncheckReference = async(incheckReferenceId, payload) =>
    {   
        store.commit('errors/CLEAR_STATE');
        // Con un tetto: senza, una richiesta appesa non si conclude mai, e chi
        // aspetta che finisca — il modale, che nel frattempo non si lascia
        // chiudere — resterebbe bloccato per sempre.
        const res = await ApiClient.patch(`incheck-reference/set-no-match/${incheckReferenceId}`, payload, { timeout: 60000 });
        if(res)
        {
            if(res.data && res.data.incheck_reference)
            {
                //addSnackbar('success', t('product.update.no_match_created', store.state.locale));
                return res.data;
            }
            else
            {
                addSnackbar('error', t('snackbar.refresh', store.state.locale));
            }
            return res;
        }

    };
    const updatePreviousResults = async (incheckReferenceId, payload) =>
    {
        store.commit('errors/CLEAR_STATE');
        const res = await ApiClient.put(`incheck-reference/update-results/${incheckReferenceId}`, payload);
        if(res.data) return res.data;
        return res;
    };

    /* Hooks */
    locale.value = store.state.locale;

    return {
        /* Methods */
        updateIncheckReference,
        destroyIncheckReference,
        setNoMatchInIncheckReference,
        updatePreviousResults
    }

};

export default IncheckReferenceService;

